import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_drive-exchange-4/artifacts/rar008ps_ChatGPT%20Image%2010%20%CE%99%CE%BF%CF%85%CE%BD%202026%2C%2006_30_59%20%CE%BC.%CE%BC..png";

export const INSTAGRAM_URL = "https://www.instagram.com/vanguardluxcars?igsh=MXFoNGgxMHJmY3hseQ==";
